@if (symbol()) {
  <img [attr.height]="height()" [attr.width]="width()" class="icon" [src]="weatherIcon" alt="">
}

